/**
 * @generated SignedSource<<924ac36734b1a45175c9e32a03e26570>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type usersSagasSaveUserMobileCredentialsCountQuery$variables = {
  customerId: string;
};
export type usersSagasSaveUserMobileCredentialsCountQuery$data = {
  readonly customer: {
    readonly availableMobileCredentials?: number;
  } | null;
};
export type usersSagasSaveUserMobileCredentialsCountQuery = {
  response: usersSagasSaveUserMobileCredentialsCountQuery$data;
  variables: usersSagasSaveUserMobileCredentialsCountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customerId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "customerId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availableMobileCredentials",
      "storageKey": null
    }
  ],
  "type": "Customer",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usersSagasSaveUserMobileCredentialsCountQuery",
    "selections": [
      {
        "alias": "customer",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usersSagasSaveUserMobileCredentialsCountQuery",
    "selections": [
      {
        "alias": "customer",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e2c8022156f3d4d0c431af412eef031a",
    "id": null,
    "metadata": {},
    "name": "usersSagasSaveUserMobileCredentialsCountQuery",
    "operationKind": "query",
    "text": "query usersSagasSaveUserMobileCredentialsCountQuery(\n  $customerId: ID!\n) {\n  customer: node(id: $customerId) {\n    __typename\n    ... on Customer {\n      availableMobileCredentials\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3fcff1f1f21af19af74dc98fe7414e78";

export default node;
